<template>
  <div class="newDetails">
    <div v-for="(item,index) in infoData" :key="index" v-html="item.NewsDesc"></div>
  </div>
</template>

<script>
export default {
 name: "newDetails",
  data(){
    return{
      infoData:[]
    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id)
  },
  methods:{
    //获取信息
    getInfo(id){
      let data = {params:{Id:id}};
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntNewsIdSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data;
        console.log(res)
      })
    }
  }

}
</script>

<style>
.esmartMargin {
  left: 0 !important;
  right: 0 !important;
  margin: 50px auto !important;
  overflow: hidden !important;
  position:static !important;
}
</style>